import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { map, find } from 'lodash';
import { Col, Divider, PageHeader, Row, Button, Icon, Select } from 'antd';

import {
  callMLServiceApiAction,
  setMLServiceApiResponseAction,
} from './actions';
import { MLWebServices } from './helpers/utils';
import APIPayload from './components/APIPayload';
import APIResponse from './components/APIResponse';
import { notifyError } from '../../utils/notify';

import './index.scss';

const { Option } = Select;
const DefaultPayload = { body: {} };

const DefaultBody = {
  'create-release-summary': {
    body: {
      fix_version: '25-Nov-2025',
      product: 'Core Product',
    },
  },
};

const MLServiceWeb = ({
  callMLServiceApi,
  mlServiceApi,
  setMLServiceApiResponse,
}) => {
  const [currentMLService, setCurrentMLService] = useState();
  const [payload, setPayload] = useState(DefaultPayload);

  const selectMLService = value => {
    if (currentMLService !== value) {
      setCurrentMLService(value);
      setPayload(DefaultBody[value] || DefaultPayload);
      setMLServiceApiResponse({ loading: false, response: null });
    }
  };
  const handleClearPayload = () => {
    setPayload(DefaultPayload);
  };

  const setPayloadBody = newBodyParam => {
    const transformedData = {};
    if (currentMLService === 'recommendation' && newBodyParam?.query_id) {
      if (Number(newBodyParam?.query_id)) {
        transformedData.query_id = Number(newBodyParam?.query_id);
      }
    }
    if (newBodyParam.body) {
      setPayload({
        ...payload,
        body: {
          ...payload.body,
          ...newBodyParam,
        },
        newBodyParam,
      });
    } else {
      setPayload({
        ...payload,
        body: {
          ...payload.body,
          ...newBodyParam,
          ...transformedData,
        },
      });
    }
  };

  const handleSubmit = () => {
    let finalBody = payload.body;
    try {
      if (payload.newBodyParam) {
        const jsonBody = JSON.parse(payload.newBodyParam.body);
        finalBody = {
          ...finalBody,
          ...jsonBody,
        };
      }
      if (finalBody.body && typeof finalBody.body === 'string') {
        finalBody = JSON.parse(finalBody.body);
      }
    } catch (err) {
      notifyError(err, false, 'Error parsing body as json');
    }
    callMLServiceApi({
      service: 'pg_ml_llm',
      api: currentMLService,
      body: finalBody,
    });
  };

  const mlService = find(MLWebServices, { value: currentMLService });
  return (
    <>
      <PageHeader
        title="ML Service Web"
        subTitle="ML Service for the various ML Web Services"
      >
        <Divider />
        <Row type="flex" gutter={32} className="ml-service-api">
          <Col span={6}>
            <div>Select the ML Web Service</div>
            <Select
              placeholder="Select Service"
              onChange={d => selectMLService(d)}
              value={currentMLService}
              style={{ width: '100%' }}
            >
              {map(MLWebServices, source => (
                <Option key={source.value} value={source.value}>
                  {source.name}
                </Option>
              ))}
            </Select>
          </Col>
          {mlService && (
            <>
              <Col span={16} style={{ marginTop: '16px' }}>
                <div>{mlService?.InfoComponent()}</div>
              </Col>
            </>
          )}
        </Row>
        <Divider />
        <APIPayload
          currentMLService="pg_ml_llm"
          currentApi={currentMLService}
          body={payload.body}
          setBody={setPayloadBody}
        />
        <Row
          type="flex"
          justify="center"
          gutter={10}
          style={{ marginTop: '10px' }}
        >
          <Col span={5}>
            <Button
              type="primary"
              onClick={() => handleSubmit()}
              style={{ width: '100%' }}
              loading={mlServiceApi.loading}
              disabled={!currentMLService}
            >
              <Icon type="filter" />
              Submit
            </Button>
          </Col>
          <Col span={4}>
            <Button
              disabled={mlServiceApi.loading}
              onClick={() => handleClearPayload()}
              style={{ width: '100%' }}
            >
              <Icon type="sync" />
              Clear All
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className="ml-service-api-content">
        <APIResponse
          currentMLService={currentMLService}
          response={mlServiceApi.response}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  callMLServiceApi: callMLServiceApiAction,
  setMLServiceApiResponse: setMLServiceApiResponseAction,
};

const mapStateToProps = ({ MLService: { mlServiceApi } }) => ({
  mlServiceApi,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MLServiceWeb)
);
